import {
    RxJsonSchema
} from 'rxdb';
import { TaskLog } from '../models/task-log';

const schema: RxJsonSchema<TaskLog> = {
    title: 'task-log schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true,
            default: ''
        },
        taskId: {
            type: 'string'
        },
        text: {
            type: 'string'
        },
        userId: {
            type: 'string'
        },
        timestamp: {
            type: 'string'
        },
        archived: {
            type: 'boolean'
        }
    },
    required: ['_id', 'text', 'taskId', 'userId'],
    indexes: [ '_id', 'taskId','userId','timestamp']
};

export default schema;